export const UPDATE_MEMBER_VERIFY_LOADING = "UPDATE_MEMBER_VERIFY_LOADING"
export const UPDATE_MEMBER_VERIFY_PHONE = "UPDATE_MEMBER_VERIFY_PHONE"
export const UPDATE_MEMBER_VERIFY_REQUEST = "UPDATE_MEMBER_VERIFY_REQUEST"
export const UPDATE_MEMBER_VERIFY_REQUEST_FORM = "UPDATE_MEMBER_VERIFY_REQUEST_FORM"